module.exports = __webpack_public_path__ + "static/media/item-1-03.65ddec8d.svg";